import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function ScrollReveal({
  children,
  y = 40,
  delay = 0,
  duration = 1.1,
  className = "",
  once = true,
  amount = 0.3,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration, delay, ease: [0.2, 0.7, 0.1, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
